module.exports = __webpack_public_path__ + "media/images/default/pages/public_science_1/3-82949fd8b08f0768cf45d3f8d6158b3e.jpeg";